<template>
  <div class="w-full h-full">
    <div
      class="flex w-full h-full flex-col justify-center items-center"
      :id="'service_button_' + service.id"
    >
      <div
        @click="$emit('click')"
        class="p-6 rounded-[3rem] overflow-hidden ripple serviceBlock border w-full h-full"
        :style="{ backgroundColor: service.color }"
        :id="'service_block_' + service.id"
      >
        <!-- <div class="py-4"></div> -->
        <div
          class="p-1 top-0 left-0 [&_.circle]:rounded-full [&_.circle]:bg-white [&_.circle]:bg-opacity-20 [&_.circle]:w-full [&_.circle]:h-full [&_.circle]:p-2"
        >
          <div class="circle -mt-8 -mb-4 scale-[1.2] !bg-opacity-0">
            <div class="circle">
              <div class="circle">
                <img
                  :src="service?.logo"
                  class="object-contain w-[4rem] min-w-[4rem] h-[4rem] relative rotate-[-10deg] scale-[1.4] rounded-[1.5rem]"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center font-bold text-2xl w-min mx-auto">
          {{ service.name }}
        </div>
        <div class="py-2"></div>
        <div class="text-center font-bold text-xl">
          {{ service.description }}
        </div>
        <div class="py-1"></div>
        <!-- <div class="text-center font-bold">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi
          doloribus rerum libero nequ
        </div> -->
        <!-- <div class="py-4"></div> -->
      </div>
    </div>
    <!-- {{ service }} -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default defineComponent({
  name: 'ServiceBlock',
  components: {},
  props: {
    service: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  mounted() {
    // this.initAnimation()
  },
  methods: {
    initAnimation() {
      let tl = gsap.timeline({
        scrollTrigger: {
          scroller: '#servicesScroller',
          trigger: '#service_block_' + this.service.id, // start the animation when ".box" enters the viewport (once)
          // markers: true,
          scrub: true,
          pin: true,
          start: 'top 80%',
          end: 'top 0px',
        },
      })
      tl.from('#service_block_' + this.service.id, {
        height: 60,
        // height: 27 * 15,
        duration: 1,
      })
      tl.to('#service_block_' + this.service.id, {
        height: 27 * 12,
        duration: 1,
        y: -27 * 12 * 2,
      }).to('#service_block_' + this.service.id, {
        height: 60,
        duration: 1,
        // delay: 4,
        // y: -27 * 12 * 2,
      })

      // gsap.to('#service_block_' + this.service.id)
    },
  },
})
</script>
